"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubNbOperationsDerniersMoisTrads = void 0;
exports.ESubNbOperationsDerniersMoisTrads = {
    more_then_ten: "Plus de 10",
    one_to_five: "De 1 à 5",
    none: "Aucune",
    six_to_ten: "De 6 à 10",
};
